import { Online } from '@nicejob/nicejob-toolbox';
import { NiceJobProjectId } from '../../../../../../../../types/common.types';

export function trackRegistrationInMagentrix(data: {
    info: {
        user_name: string;
        email: string;
    };
}): boolean {
    try {
        if (
            !Online ||
            process.env.REACT_APP_PROJECT_ID !== NiceJobProjectId.production ||
            !mgxPartnerTrack
        ) {
            return false;
        }

        const {
            info: { user_name, email },
        } = data;

        // global-scoped, see login-route/custom.d.ts
        mgxPartnerTrack.trackSignup({
            name: user_name || '',
            email: email || '',
            customerKey: email || '',
        });

        return true;
    } catch (error) {
        // no throw
        return false;
    }
}
